angular.module("LeasePilot").factory("LeaseVarService", [
  "$filter",
  "$sanitize",
  "$rootScope",
  "$timeout",
  function ($filter, $sanitize, $rootScope, $timeout) {

    /**
     * True when the string likely contains Markdown or safe inline HTML we render via Showdown.
     * Avoids running the converter on plain text (numbers formatted as strings, legal copy, etc.).
     */
    const leaseVarValueLooksLikeMarkdown = function (raw) {
      if (typeof raw !== "string" || raw === "") {
        return false;
      }
      return (
        /\*\*/.test(raw) ||
        /\*[^*\n]+\*/.test(raw) ||
        /__[^_\n]+__/.test(raw) ||
        /(?:^|\s)_[^_\n]+_(?=\s|[.,;:!?)'\]]|$)/m.test(raw) ||
        /`[^`]+`/.test(raw) ||
        /\[[^\]]+\]\([^)\n]+\)/.test(raw) ||
        /^\s*#{1,6}\s/m.test(raw) ||
        /<\/?(u|em|strong|b|i|code)\b/i.test(raw)
      );
    };

    /**
     * Renders a subset of Markdown as inline HTML: **bold**, *italic*, __bold__, _italic_,
     * `code`, and raw inline tags such as <u>…</u> for underline. Output is meant to be passed
     * through $sanitize. Requires global showdown (see application layout script includes).
     */
    const leaseVarMarkdownToHtml = function (raw) {
      if (typeof raw !== "string" || raw === "") {
        return raw;
      }
      if (typeof window.showdown === "undefined") {
        return raw;
      }
      var converter = new showdown.Converter({
        simpleLineBreaks: true,
        strikethrough: false,
        tables: false,
        tasklists: false,
        disableForced4SpacesIndentedSublists: true,
      });
      var html = converter.makeHtml(raw);
      html = html.trim();
      if (/^<p[\s>]/.test(html) && /<\/p>\s*$/i.test(html)) {
        html = html.replace(/^<p[^>]*>\s*/i, "").replace(/\s*<\/p>\s*$/i, "");
      }
      html = html.replace(/<\/p>\s*<p[^>]*>/gi, "<br>");
      return html;
    };

    const generateLine = function (l, s = "_") {
      if (l && l > 0) {
        return new Array(l + 1).join(s);
      } else {
        return new Array(11).join(s);
      }
    };

    const leaseVarClick = (event, scope, element, attrs) => {
      if (
        !$(event.target)
        .closest(".lease")
        .hasClass("lease--original")
      ) {
        return;
      }

      var scopeVar = $rootScope.findAppScope(scope);

      if (scopeVar.inline.on) {
        var relateds = scopeVar.inline.findNestedControls(element);

        // remove yourself from array and reposition at beginning
        var myIdx = relateds.indexOf(attrs.name);
        if (myIdx > -1) {
          relateds.splice(myIdx, 1);
        }
        relateds.unshift(attrs.name);

        relateds = scopeVar.inline.util.checkRelateds(relateds, element);
        scopeVar.inline.mouseX = event.clientX;
        scopeVar.inline.mouseY = event.clientY;
        $("#active-element-anchor").remove();
        scopeVar.inline.openInline(element, relateds);
        event.stopPropagation(); // Stop so that the inline isn't opened by the lease-if that it is within
      } else if (leftSideEditorSearch) {
        scopeVar.leftPane = "deal-terms";
        leftSideEditorSearch.searchByLeaseVarElement(element);
      }

      window.track.event(new ClickOnALeaseVarEvent({
        name: attrs.name
      }));
    };

    const leaseVarChangeWatch = (newval, scope, element, attrs) => {
      var scopeVar = $rootScope.findAppScope(scope);

      if (attrs.name === "building.name") {
        if (scopeVar.building.displayName) {
          newval[0] = scopeVar.building.displayName;
        }
      }

      if (
        (attrs["calc"] &&
          scope.calc !== null &&
          scope.calc !== undefined &&
          scope.calc !== "" &&
          scope.calc !== Infinity &&
          scope.calc !== "NaN" &&
          !Number.isNaN(scope.calc)) ||
        (!attrs["calc"] &&
          newval[0] !== null &&
          newval[0] !== undefined &&
          newval[0] !== "" &&
          newval[0] !== Infinity &&
          !Number.isNaN(newval[0]))
      ) {
        var processedVal = attrs["calc"] ? scope.calc : newval[0];

        if (scope.f1) {
          processedVal = $filter(scope.f1)(processedVal, scope.f1Options);
        }
        if (scope.f2) {
          processedVal = $filter(scope.f2)(processedVal, scope.f2Options);
        }
        if (scope.f3) {
          processedVal = $filter(scope.f3)(processedVal, scope.f3Options);
        }

        try {
          if (
            typeof processedVal === "string" &&
            leaseVarValueLooksLikeMarkdown(processedVal)
          ) {
            processedVal = leaseVarMarkdownToHtml(processedVal);
          }
          processedVal = $sanitize(processedVal);
        } catch (ex) {
          processedVal = "";
        }

        if (scope.isChanging) {
          if (element.closest('lease-var[hl]').length === 0) {
            element.html(
              "<span contenteditable='false' class='adding'>" +
              processedVal +
              "</span>"
            );
          } else {
            element.html(
              "<span contenteditable='false' class='added'>" +
              processedVal +
              "</span>"
            );
          }
        } else {
          element.html(
            "<span contenteditable='false' class='added'>" +
            processedVal +
            "</span>"
          );
        }
      } else if (!scope.ll && typeof scope.ev !== "undefined") {
        var ev = scope.ev;
        if (!isNaN(scope.ev)) {
          let prefix = "";

          if (scope.f1 === "currency" || scope.f2 === "currency" || scope.f3 === "currency") {
            prefix = "$";
          }

          // if ev is a number, create a string of spaces with that number as length
          ev = prefix + generateLine(ev * 1, "&nbsp;");
        }
        element.html(
          "<span contenteditable='false'" +
          (scope.isChanging ? " class='adding'" : "") +
          ">" +
          ev +
          "</span>"
        );
      } else {
        let prefix ="";

        if (scope.f1 === "currency" || scope.f2 === "currency" || scope.f3 === "currency") {
          prefix = "$";
        }

        element.html(
          "<span contenteditable='false'" +
          (scope.isChanging ? " class='adding'" : "") +
          ">" +
          prefix + generateLine(scope.ll) +
          "</span>"
        );
      }
    };

    const setTitle = (scope, element, LabelsService) => {

      if ($rootScope.findAppScope(scope).inline.on) {
        element.attr("title", "");
      } else if (scope.varName && $rootScope.fullLabels) {
        element.attr(
          "title",
          $rootScope.fullLabels[LabelsService.normalize(scope.varName)]
        );
      }
    };

    const setTitles = (scope, LabelsService) => {
      document.querySelectorAll("lease-var").forEach(node => {
        setTitle(scope, $(node), LabelsService);
      });
    };

    const isChangeStructure = (map, name) => {
      return !!map[name];
    }

    return {
      leaseVarClick: leaseVarClick,
      leaseVarChangeWatch: leaseVarChangeWatch,
      setTitles: setTitles,
      setTitle: setTitle,
      isChangeStructure: isChangeStructure,
    };
  }
]);
